import React, { useState } from 'react';
import styles from './legend.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { compose as C, keys, map as m, prop as p, reverse } from 'ramda';
import QRCode from 'react-qr-code';
import { toggle_legend } from '../../store/load_data';

export const Legend = () => {
    const [colors,meanings,country,comparison,countries,opened,eust_nr] = m(C(useSelector,p),["colors","color_meaning","country","comparison","countries","legend_open","eust_nr"]);
    const dispatch = useDispatch();
    const compare = comparison.length !== keys(countries).length ? `&comparison=${comparison.join(",")}` :"";
    
    return <>
        <div className={`placeholder ${styles.placeholder}`}>
        </div>
        <div className={`legend ${styles.legend} ${opened ? styles.opened : ""}`} 
            onClick={x => dispatch(toggle_legend())}>
            {reverse(colors).map((x,n) => <div key={`legend${n}`} className={styles.color} style={{borderColor:x}}>
                <span>{reverse(meanings)[n]}</span>
            </div>)}
        </div>
        <h2 className={styles.qrtext} >For more information, use the online tool</h2>
        <QRCode value={`https://countryprofiles.eurostudent.eu?country=${country}&eust_nr=${eust_nr}${compare}`} 
            className={styles.qr} fgColor="#2C70D4" size={120}/>
    </>
}